
import { Component, Inject, TemplateRef, ViewChild, DOCUMENT } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../data/data.service';
@Component({
    selector: 'app-tablet-layout',
    template: `
    <ng-template #menu let-offcanvas>
      <div class="offcanvas-body p-0">
        <app-navbar (actionButtonPressed)="offcanvas.dismiss()">
          <button class="btn text-muted btn-focus-no-shadow menu-button" type="button" (click)="offcanvas.dismiss()" start>
            <span class="material-icons md-24">menu</span>
          </button>
        </app-navbar>
      </div>
    </ng-template>
    <div class="w-100 pt-5 h-100">
      <app-header>
        <div start>
          <button class="btn text-muted btn-focus-no-shadow py-1" type="button" (click)="openMenu()">
            <span class="position-relative">
              <span class="material-icons md-24">menu</span>
              <span *ngIf="dataService.reservationAndPickupCount !== 0"
                    class="position-absolute top-neg start-100 translate-middle badge rounded-pill bg-danger">!</span>
            </span>
          </button>
        </div>
      </app-header>
      <router-outlet></router-outlet>
    </div>
    <app-alerts-container position="top-center"></app-alerts-container>
    <app-feedback></app-feedback>
  `,
    styles: [`
    @use 'variables' as *;
    :host {
      display: block;
      height: 100vh; /* Use vh as a fallback for browsers that do not support Custom Properties */
      height: calc(var(--vh-mobile, 1vh) * 100);
    }
    @media (min-height: $screen-height-desktop) {
      .menu-button {
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
    }
    .top-neg {
      top: -8px;
    }
  `],
    standalone: false
})
export class MobileLayoutComponent {
  @ViewChild('menu') menu!: TemplateRef<any>;
  constructor(@Inject(DOCUMENT) private readonly document: Document,
    private readonly offcanvasService: NgbOffcanvas,
    public readonly dataService: DataService) {
    this.setViewportHeight();
    window.addEventListener('resize', () => {
      this.setViewportHeight();
    });
  }
  openMenu() {
    this.offcanvasService.open(this.menu, {
      panelClass: 'w-auto bg-transparent border-0'
    });
  }
  /** Viewport height for mobile browsers needs to be recalculated to use the inner height of window,
   * this way content will not go under mobile browsers header and footer
   */
  private setViewportHeight() {
    const vhPercent = window.innerHeight * 0.01;
    this.document.body.style.setProperty('--vh-mobile', `${vhPercent}px`);
  }
}
